import {useMemo} from "react";
import {RrcEp10WasteManifestEntity} from "@ots-frontend/ots-data";
import {
  DataTableFilterConfig,
  useDataTableFilter,
  UseDataTableFilterProps,
  UseDataTableFilterResult
} from "../DataTable/useDataTableFilter";
import {useTranslation} from "react-i18next";

export type UseRrcEp10WasteManifestDataTableFilterProps = Omit<UseDataTableFilterProps<RrcEp10WasteManifestEntity>, 'filterConfig'>

export function useRrcEp10WasteManifestDataTableFilter(props: UseRrcEp10WasteManifestDataTableFilterProps): UseDataTableFilterResult<RrcEp10WasteManifestEntity> {
  const {records} = props;

  const {t} = useTranslation(["common"])

  const filterConfig: DataTableFilterConfig<RrcEp10WasteManifestEntity> = useMemo(() => {
    return {}
  }, [
    t
  ])

  const {filteredRecords} = useDataTableFilter({
    records: records,
    filterConfig: filterConfig,
  })

  return {
    filteredRecords: filteredRecords,
    filterConfig: filterConfig
  };
}
